<template>
  <section data-background-color="black">
    <div
      class="sl-block"
      data-block-type="text"
      style="width: 700px; margin: auto"
    >
      <div class="clockCanvas" :id="canvasId" ref="clock" />
    </div>
  </section>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Highcharts from "highcharts";
import More from "highcharts/highcharts-more";
More(Highcharts);

Math.easeOutBounce = function (pos) {
  if (pos < 1 / 2.75) {
    return 7.5625 * pos * pos;
  }
  if (pos < 2 / 2.75) {
    return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
  }
  if (pos < 2.5 / 2.75) {
    return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
  }
  return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
};

export default {
  name: "",
  props: [],
  components: {},
  beforeMount() {
    this.now = this.getNow();
  },
  mounted() {
    let me = this;
    this.$nextTick(function () {
      this.chart = Highcharts.chart(document.getElementById(this.canvasId), {
        chart: {
          type: "gauge",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: "90%",
          backgroundColor: "#000000",
          events: {
            load: function () {
              me.addLogo();
            },
          },
        },

        exporting: false,

        credits: {
          enabled: false,
        },

        title: null,

        pane: {
          background: [
            {
              // default background
            },
            {
              // reflex for supported browsers
              backgroundColor: Highcharts.svg
                ? {
                    radialGradient: {
                      cx: 0.5,
                      cy: -0.4,
                      r: 1.9,
                    },
                    stops: [
                      [0.5, "rgba(255, 255, 255, 0.2)"],
                      [0.5, "rgba(200, 200, 200, 0.2)"],
                    ],
                  }
                : null,
            },
          ],
        },

        yAxis: {
          labels: {
            distance: -20,
          },
          min: 0,
          max: 12,
          lineWidth: 0,
          showFirstLabel: false,

          minorTickInterval: "auto",
          minorTickWidth: 1,
          minorTickLength: 5,
          minorTickPosition: "inside",
          minorGridLineWidth: 0,
          minorTickColor: "#666",

          tickInterval: 1,
          tickWidth: 2,
          tickPosition: "inside",
          tickLength: 10,
          tickColor: "#666",
          title: {
            class: "foo",
            text: "Find Me",
            useHTML: false,
            style: {
              color: "#BBB",
              font: "Poppins",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "15px",
            },
            y: 10,
          },
        },

        tooltip: {
          formatter: function () {
            return this.series.chart.tooltipText;
          },
        },

        series: [
          {
            data: [
              {
                id: "hour",
                y: this.now.hours,
                dial: {
                  radius: "60%",
                  baseWidth: 4,
                  baseLength: "95%",
                  rearLength: 0,
                },
              },
              {
                id: "minute",
                y: this.now.minutes,
                dial: {
                  baseLength: "95%",
                  rearLength: 0,
                },
              },
              {
                id: "second",
                y: this.now.seconds,
                dial: {
                  radius: "100%",
                  baseWidth: 1,
                  rearLength: "20%",
                },
              },
            ],
            animation: false,
            dataLabels: {
              enabled: false,
            },
          },
        ],
      });
    });

    me.timer = setInterval(function () {
      let now = me.getNow();

      if (me.chart.axes) {
        // not destroyed

        var hour = me.chart.get("hour"),
          minute = me.chart.get("minute"),
          second = me.chart.get("second"),
          // run animation unless we're wrapping around from 59 to 0

          animation =
            now.secs === 0
              ? false
              : {
                  easing: "easeOutBounce",
                };

        // Cache the tooltip text
        me.chart.tooltipText =
          me.pad(Math.floor(now.hours), 2) +
          ":" +
          me.pad(Math.floor(now.minutes * 5), 2) +
          ":" +
          me.pad(now.seconds * 5, 2);

        hour.update(now.hours, true, animation);
        minute.update(now.minutes, true, animation);
        second.update(now.seconds, true, animation);
      }
    }, 1000);
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  data() {
    return {
      moment: moment,
      now: null,
      canvasId: "highclock",
      chart: null,
      timer: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    addLogo() {
      this.$nextTick(function () {
        let clock = this.$refs.clock;
        let el = clock.querySelector(".highcharts-axis-title");

        // replace title with logo
        let logoItem = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );
        logoItem.setAttribute("width", 300);
        logoItem.setAttribute("height", 300);
        logoItem.setAttribute("x", 207);
        logoItem.setAttribute("y", 162);

        let logo = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "image"
        );
        logo.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "href",
          "/img/agrifyClockLogo.png"
        );
        logo.setAttribute("width", 300);
        logo.setAttribute("height", 300);

        logoItem.appendChild(logo);

        // el.after(logoItem);

        el.parentNode.replaceChild(logoItem, el);
      });
    },
    getNow() {
      let now = moment.utc().add(this.getUser.facility_UTCOffset, "hours");

      return {
        hours: now.hour() + now.minutes() / 60,
        minutes: (now.minutes() * 12) / 60 + (now.seconds() * 12) / 3600,
        seconds: (now.seconds() * 12) / 60,
        secs: now.seconds(),
      };
    },
    pad(number, length) {
      // Create an array of the remaining length + 1 and join it with 0's
      return (
        new Array((length || 2) + 1 - String(number).length).join(0) + number
      );
    },
  },
};
</script>
<style>
</style>

